import cx from 'classnames';
import React from 'react';

import './modal__content.scss';

interface Props {
    mix?: string;
    children: React.ReactNode | Array<React.ReactNode>;
}

export const ModalContent = ({ children, mix }: Props) => <div className={cx('modal__content', mix)}>{children}</div>;
